
export function Header() {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900">
            onwardSEO URL Keyword Analyzer
          </h1>
          <p className="mt-3 text-base text-gray-600 max-w-3xl mx-auto leading-snug">
            Instantly uncover the keywords and content structure driving results for any webpage. Whether you're crafting competitive content or fine-tuning your own site, this tool gives you the edge you need to rank higher and attract the right audience.
          </p>
          <p className="mt-3 text-lg font-semibold text-blue-600">
            See What Works, Implement What Wins, and Start Ranking Today!
          </p>
        </div>
      </div>
    </header>
  );
}